import { configureStore } from '@reduxjs/toolkit';
import filterReducer from '../features/filter/filterTransactions';
import transactionReducer from '../features/transactions/transactionsSlice';

const store = configureStore({
    reducer: {
        transaction: transactionReducer,
        filter: filterReducer
    }
});

export default store;
